<template>
<div>

  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="项目施工出入证">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="A证" >
        <el-link type="primary" class="el-link-common" @click="getFile('项目施工出入证.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>

  </el-descriptions>
</div>
</template>

<script>
import FitmentFileSubgroup from "../FitmentFileSubgroup";
import AppConfig from "../../../../../../../../config/AppConfig";
export default {
  name: "CertificateProcessing",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{

    }
  },
  methods:{
    getFile(file_name) {
      let url=AppConfig.erp_server+"/admin/HouseFurnish/download?file_name="+file_name;
      window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/components/preparation_entry/CertificateProcessing.vue